import Vue from 'vue'
import './utils/base.js'

import App from './App.vue'
import router from './router'

import global from '@/utils/global.js'
Vue.prototype.$global = global


import Mui from 'vue-awesome-mui'
Vue.use(Mui)

Vue.config.productionTip = false

new Vue({
  data: {
    global
  },
  router,
  render: h => h(App)
}).$mount('#app')
